import { Spinner } from "react-bootstrap";

export const Loading = () => {
  return (
    <div className="d-flex vh-100 w-100 justify-content-center align-items-center bg-dimblue">
      <Spinner animation="border" variant="grayblue" />
    </div>
  );
};
